import React from 'react';
import { useTranslation } from 'react-i18next';
import { LeaveApprovalDashboard } from '../leave/components/LeaveApprovalDashboard';
import { CalendarDays } from 'lucide-react';

export const LeaveApprovalsPage: React.FC = () => {
  const { t } = useTranslation('manager');

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <span className="inline-flex items-center justify-center w-12 h-12 rounded-[14px] bg-gradient-to-br from-orange-400 to-amber-500 text-white shadow-sm">
          <CalendarDays className="w-6 h-6" />
        </span>
        <div>
          <h1 className="text-h2 text-charcoal">{t('leave_approvals.title', { defaultValue: 'Leave Approvals' })}</h1>
          <p className="text-muted-foreground mt-1">
            {t('leave_approvals.subtitle', { defaultValue: 'Review and approve your team’s time-off requests.' })}
          </p>
        </div>
      </div>

      <LeaveApprovalDashboard />
    </div>
  );
};

export default LeaveApprovalsPage;
